import { calculateRetailCommissionOptions } from '@svs/nova-marketplace-sport/utils';

/**
 * Generates an array of commission percentage options based on the maximum commission, share price, and sold shares.
 *
 * @param root0 - An object containing the maximum commission, share price, and sold shares.
 * @param root0.maxCommission - The maximum commission percentage.
 * @param root0.sharePrice - The price of a single share.
 * @param root0.soldShares - The number of shares sold.
 * @returns An array of commission percentage options from 0 to the maximum commission.
 */
export function getCommissionPercentOptions({
  maxCommission,
  sharePrice,
  soldShares,
}: {
  maxCommission: number;
  sharePrice: number;
  soldShares: number;
}): number[] {
  const options = calculateRetailCommissionOptions(soldShares, sharePrice, maxCommission);
  return options;
}
